/**
 * The five windows, in the order the picker shows them. `key` MUST equal the
 * `period` column values produced by v_periods.sql in zealth-analytics: they are
 * the join between the picker and every windowed panel, and a mismatch empties
 * the page silently rather than erroring.
 *
 * `weeks` / `days` are about chart GRAIN only — which time series to draw and
 * how much of it. Every other measure is windowed in SQL.
 */
export const INSIGHTS_PERIODS = [
  { key: 'all', label: 'All time', weeks: null, days: null },
  { key: '180d', label: 'Last 6 months', weeks: 26, days: null },
  { key: '90d', label: 'Last 3 months', weeks: 13, days: null },
  { key: '30d', label: 'Last 30 days', weeks: null, days: 30 },
  { key: '7d', label: 'Last 7 days', weeks: null, days: 7 },
] as const

export type InsightsPeriod = (typeof INSIGHTS_PERIODS)[number]
export type InsightsPeriodKey = InsightsPeriod['key']

/** All time by default: the early website-only weeks explain the later shape. */
export const DEFAULT_PERIOD: InsightsPeriod = INSIGHTS_PERIODS[0]
